import Base from './Base';

export type ApiTaxonomiesResponse = ApiListResponse<Taxonomy>;
export type ApiCategoriesResponse = ApiListResponse<Category>;
export type ApiTagsResponse = ApiListResponse<Tag>;
export type ApiTopicsResponse = ApiListResponse<Topic>;
export type ApiBrandsResponse = ApiListResponse<Brand>;
export type ApiFormatsResponse = ApiListResponse<Format>;

class Taxonomies extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiTaxonomiesResponse>(
            '/taxonomies',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    brands(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiBrandsResponse>(
            '/brands',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    categories(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiCategoriesResponse>(
            '/categories',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    tags(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiTagsResponse>(
            '/tags',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    topics(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiTopicsResponse>(
            '/topics',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    formats(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiFormatsResponse>(
            '/formats',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Taxonomies;
